<lib-app-layout (logoutClick)="logout()" [navGroups]="navGroups()" [title]="title()" [version]="version">
    <ng-container toolbar-right>
        <portal-activity-button></portal-activity-button>
        @if (info(); as info) {
            <div [matMenuTriggerFor]="userMenu" class="flex items-center gap-2 cursor-pointer px-2">
                <div class="w-8 h-8 rounded-full bg-slate-600 flex items-center justify-center text-white text-xs font-semibold select-none">{{ info.firstName[0] }}{{ info.lastName[0] }}</div>
                <span class="text-sm font-medium hidden md:block">{{ info.firstName }} {{ info.lastName }}</span>
            </div>
        }
    </ng-container>
</lib-app-layout>

<mat-menu #userMenu="matMenu" panelClass="user-menu-panel">
    <button mat-menu-item routerLink="/account" routerLinkActive="active-route">
        <mat-icon>admin_panel_settings</mat-icon>
        <span>{{ 'profile.title' | translate }}</span>
    </button>
    <button mat-menu-item routerLink="/address" routerLinkActive="active-route">
        <mat-icon>contact_mail</mat-icon>
        <span>{{ 'address.title' | translate }}</span>
    </button>
    <button mat-menu-item routerLink="/activity" routerLinkActive="active-route">
        <mat-icon>notifications</mat-icon>
        <span>{{ 'activity.title' | translate }}</span>
    </button>
    <mat-divider></mat-divider>
    <button (click)="logout()" mat-menu-item>
        <mat-icon>logout</mat-icon>
        <span>{{ 'action.logout' | translate }}</span>
    </button>
</mat-menu>
